<template>
  <transition-height-expand>
    <ul
      class='sub-navigation'
      v-show="isVisible"
    >
      <li class="sub-navigation-header">
        <router-link
          v-bind:to="`/${section.alias}`"
          v-on:click.native="hideParentNavigation()"
        >
          {{ section.short_name }}
        </router-link>
      </li>
      <li
        v-for="category in section.categories"
        v-bind:key="category.alias"
      >
        <router-link
          v-bind:to="`/${section.alias}/${category.alias}`"
          v-on:click.native="hideParentNavigation()"
        >
          {{ category.short_name }}
        </router-link>
      </li>
    </ul>
  </transition-height-expand>
</template>

<script>
import TransitionHeightExpand from '@/components/utils/TransitionHeightExpand'

export default {
  name: 'NavigationMainSubLevel',
  components: { TransitionHeightExpand },
  props: ['section', 'isVisible'],
  data: function () {
    return {}
  },
  methods: {
    hideParentNavigation: function () {
      this.$emit('hide-main-navigation')
    }
  }
}
</script>

<style scoped lang="scss">
  $sub-navigation-desktop-padding-left: 105px;
  $sub-navigation-desktop-width: 645px;

  .sub-navigation {
    background-color: rgba(0, 0, 0, .5);
    line-height: 3em;

    @include media(">desktop") {
      position: fixed;
      left: 0;
      top: $the-header-main-height + $the-header-contacts-height;
      padding:
        5.5em calc(100% - #{$sub-navigation-desktop-width})
        3em $sub-navigation-desktop-padding-left;
      column-count: 2;
      width: 100%;
    };
    @include media("<=desktop") {
      position: relative;
      left: 0;
      top: 0;
      padding-bottom: 1em;
      background-image: linear-gradient(
          to right,
          rgba(0,0,0,0.4), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.4));
    };

    & > li {
      display: block;
      @include media(">desktop") { text-align: left; };

      & > a {
        display: inline-block;
        height: 100%;
        @include media(">desktop") { padding-left: 1em; };
      }
    }

    & > .sub-navigation-header {
      @include media(">desktop") {
        position: absolute;
        left: $sub-navigation-desktop-padding-left;
        top: 2em;
      };
      @include media("<=desktop") {
        position: relative;
        left: 0;
        top: 0;
      };

      & > a {
        color: $active-link-color;
        line-height: 3.5em;
        text-transform: uppercase;

        @include media(">desktop") {
          padding: 0 0.5em;
          transition: padding 0.3s;
        };
        @include media("<=desktop") {
          border-bottom: 1px solid $default-link-color;
          padding: 0 1em;
        };

        &:hover {
          @include media(">desktop") { padding: 0 1em; };
        }
      }
    }

    &.height-expand {
      &-enter-active, &-leave-active {
        @include media(">desktop") {
          transition: opacity 0.7s ease;
          visibility: visible;
          opacity: 1;
        };
      }
      &-enter, &-leave-to {
        @include media(">desktop") {
          visibility: hidden;
          opacity: 0;
        };
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-header/navigation-main/NavigationMainSubLevel.vue